import type { MessageStatusName, PlatformTypeName } from "@multi-chat/shared";

/**
 * WhatsApp delivery ticks (✓ / ✓✓) must not be shown for Messenger/Instagram.
 * Clock/spinner/failed remain generic across platforms.
 */
export type MessageStatusPresentationKind =
  | "utility" // clock / spinner / failed
  | "whatsapp_ticks"
  | "plain_label";

export function messageStatusPresentationKind(
  platformType: PlatformTypeName,
  status: MessageStatusName,
): MessageStatusPresentationKind | null {
  if (status === "RECEIVED") {
    return null;
  }

  switch (status) {
    case "PENDING":
    case "SENDING":
    case "FAILED":
      return "utility";
    case "SENT":
    case "DELIVERED":
    case "READ":
      return platformType === "WHATSAPP" ? "whatsapp_ticks" : "plain_label";
    default: {
      const _exhaustive: never = status;
      return _exhaustive;
    }
  }
}

export function usesWhatsAppDeliveryTicks(platformType: PlatformTypeName): boolean {
  return platformType === "WHATSAPP";
}
